module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/qr.818e4759.jpg";